<template>
  <MaskLayer v-show="isOpen">
    <PopupReturn class="te-alert-md no-alert-btn" :isOpen.sync="isOpen">
      <div
        class="w-100 mb-3 d-flex align-items-center justify-content-between bg-light"
      >
        <div class="p-3" v-if="pageType==='return'">
          <h6 v-if="pageType==='return'">{{ $t("order.return.application") }}</h6>
          <h6 v-if="pageType==='cancel'">{{ $t("order.cancel.application") }}</h6>
          <div class="font-size-md">
            {{ $t("order.orderId") }} {{ order.orderId }}
          </div>
        </div>
      </div>
      <McfReturnRequest
        :order="order"
        :pageType="pageType"
        @close="close"
      />
    </PopupReturn>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import PopupReturn from '@/components/return/Popup.vue';
import McfReturnRequest from '@/components/return/McfReturnRequest.vue';

export default {
  components: {
    MaskLayer,
    PopupReturn,
    McfReturnRequest,
  },
  props: {
    // 是否顯示退款頁
    isPageOpen: {
      type: Boolean,
      default: false,
    },
    // 取消或是退貨
    pageType: {
      type: String,
      default: '',
    },
    // 訂單資訊
    order: {
      type: Object,
      default: null,
    },
    // 取消訂單內容
    cancelOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // 是否顯示此頁
      isOpen: false,
    };
  },
  created() {
    this.isOpen = this.isPageOpen;
  },
  watch: {
    isOpen(val) {
      this.$emit('update:isPageOpen', val);
    },
    isPageOpen() {
      this.isOpen = this.isPageOpen;
    },
  },
  methods: {
    close() {
      this.isOpen = false;
    },
  },
};
</script>
